export default "__VITE_ASSET__bDFLAlhe__"